type NoResultsProps = {
  message?: string;
};

export default function NoResults({ message = "No area code found." }: NoResultsProps) {
  return (
    <p className="rounded border border-line bg-white px-4 py-3 text-sm text-slate-700">
      {message}
    </p>
  );
}
